<template>
  <transition name="fade">
    <div v-if="isLoading" class="page-loader">
      <div class="loader-content">
        <div class="loader-spinner"></div>
        <p class="loader-text">Carregando...</p>
      </div>
    </div>
  </transition>
</template>

<script>
import { subscribeToLoading } from '../utils/loadingManager'

export default {
  name: 'PageLoader',
  data() {
    return {
      isLoading: false,
      unsubscribe: null
    }
  },
  created() {
    this.unsubscribe = subscribeToLoading((state) => {
      this.isLoading = state
    })
  },
  beforeUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  }
}
</script>

<style scoped>
.page-loader {
  position: absolute;
  inset: 0;
  background: transparent;
  backdrop-filter: none;
  border-radius: 0;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}

.loader-spinner {
  width: 60px;
  height: 60px;
  border: 5px solid rgba(229, 233, 253, 0.35);
  border-top-color: var(--brand-navy-soft);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loader-text {
  color: var(--brand-cloud);
  font-size: 19px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
